import {updateService} from '../../services/service-factory';

export default {
  data: function() {
    return {
      updateService: undefined,
    };
  },
  created: function() {
    this.updateService = updateService;
  },
  methods: {
    async updateServer() {
      await this.updateService.updateServer();
    },
    async getUpdateStatus() {
      return await this.updateService.getUpdateStatus();
    },
  }
};
